import React from "react";
import { Layout } from "../../layouts/Layout";
import { BlogPageWrapper } from "../../components/BlogAreas/BlogPageWrapper";
import { BLOG_POSTS } from "../../content/siteContent";
import { Link } from "react-router-dom";

const formatDate = (isoDate) =>
  new Date(isoDate).toLocaleDateString("en-US", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });

const BlogPage = () => {
  const posts = [...BLOG_POSTS].sort(
    (a, b) => new Date(b.publishDate) - new Date(a.publishDate)
  );

  return (
    <Layout
      breadcrumb={"Blog"}
      title={"Latest Blog"}
      seo={{
        title: "Blog - Business Registration & Tax Guides",
        description:
          "Practical, plain-language guides on SECP registration, FBR tax, PEC licensing, trademarks, and other business compliance topics in Pakistan.",
        pathname: "/blog",
      }}
    >
      <BlogPageWrapper>
        <div className="blog-post-wrap">
          {/* list */}
          <div className="row">
            {posts.map((blog) => (
              <div key={blog.id} className="col-md-6">
                <div className="blog-post-item-two">
                  <div className="blog-post-thumb-two">
                    <Link to={`/blog/${blog.slug}`}>
                      <img
                        src={`${process.env.PUBLIC_URL}/images/services-details/${blog.image}`}
                        alt={blog.imageAlt}
                        loading="lazy"
                      />
                    </Link>

                    <Link to={`/blog?category=${encodeURIComponent(blog.category)}`} className="tag tag-two">
                      {blog.category}
                    </Link>
                  </div>

                  <div className="blog-post-content-two">
                    <h2 className="title">
                      <Link to={`/blog/${blog.slug}`}>{blog.title}</Link>
                    </h2>
                    <p>{blog.excerpt}</p>

                    <div className="blog-meta">
                      <ul className="list-wrap">
                        <li>
                          <Link to={`/blog/${blog.slug}`}>
                            {blog.readTime}
                          </Link>
                        </li>
                        <li>
                          <i className="far fa-calendar"></i>
                          {formatDate(blog.publishDate)}
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </BlogPageWrapper>
    </Layout>
  );
};

export default BlogPage;

